export default "__VITE_PUBLIC_ASSET__35b6fd4f__"